import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { interaction___menu, interaction_arrows_chevronLeft, interaction___close } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { texts } from '../../utils/Localization.js';
import { fComp, fRef } from '../../utils/React.js';
import '../Grid/Grid.styles.js';
import '../Drawer/Drawer.styles.js';
import { DrawerWrapper } from '../Drawer/DrawerWrapper.js';
import { GridPresentation } from '../Grid/GridPresentation.js';
import { GridColumnPresentation } from '../GridColumn/GridColumnPresentation.js';
import '../GridColumn/GridColumnWrapper.js';
import { ThemePresentation } from '../Theme/ThemePresentation.js';
import '../_HeaderContainer/HeaderContainerPresentation.js';
import { HeaderContainerWrapper } from '../_HeaderContainer/HeaderContainerWrapper.js';
import { getGridRowClasses } from '../GridRow/GridRowPresentation.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import '../IconLink/IconLinkPresentation.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import '../IconLinkGroup/IconLinkGroupPresentation.js';
import { LogoPresentation } from '../Logo/LogoPresentation.js';
import { NavigationBarPresentation } from '../NavigationBar/NavigationBarPresentation.js';
import { NavigationBlockPresentation } from '../NavigationBlock/NavigationBlockPresentation.js';
import '../NavigationBlock/NavigationBlockWrapper.js';
import { NavigationSeparatorPresentation } from '../NavigationSeparator/NavigationSeparatorPresentation.js';
import { SectionPresentation } from '../Section/SectionPresentation.js';
import { hostClass } from './PortalHeader.styles.js';

var defaultProps = {
  onChange: function onChange() {
    /* empty */
  },
  onSegmentChange: function onSegmentChange() {
    /* empty */
  }
};
var Div = fRef(function (_a) {
  var ref = _a.ref,
      props = __rest(_a, ["ref"]);

  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  }));
});
var PortalHeaderPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var _a, _b, _c, _d;

  var id = props.id,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      activeElement = props.activeElement,
      activeRef = props.activeRef,
      activeSubmenuElement = props.activeSubmenuElement,
      activeSubmenuRef = props.activeSubmenuRef,
      activeMobileElement = props.activeMobileElement,
      activeMobileRef = props.activeMobileRef,
      activeMobileSubmenuElement = props.activeMobileSubmenuElement,
      activeMobileSubmenuRef = props.activeMobileSubmenuRef,
      navigationTree = props.navigationTree,
      segmentNavigationTree = props.segmentNavigationTree,
      value = props.value,
      _onChange = props.onChange,
      segmentValue = props.segmentValue,
      onSegmentChange = props.onSegmentChange,
      name = props.name,
      iconLinksInteraction = props.iconLinksInteraction,
      iconLinksQuickLink = props.iconLinksQuickLink,
      iconLinksMobileHeader = props.iconLinksMobileHeader,
      iconLinksMobileSidebar = props.iconLinksMobileSidebar,
      isSticky = props.isSticky,
      selectedPath = props.selectedPath,
      openPath = props.openPath,
      onOpenChange = props.onOpenChange,
      isMobile = props.isMobile,
      segmentLabel = props.segmentLabel,
      setScrollPosition = props.setScrollPosition,
      scrollPosition = props.scrollPosition,
      logoSrcMobile = props.logoSrcMobile,
      logoSrcDesktop = props.logoSrcDesktop,
      logoHref = props.logoHref,
      logoAlt = props.logoAlt,
      logoHtmlAttrs = props.logoHtmlAttrs,
      logoDisabled = props.logoDisabled,
      onLogoClick = props.onLogoClick,
      navigationBarRef = props.navigationBarRef,
      mobileMenuLinkRef = props.mobileMenuLinkRef,
      onHeaderClick = props.onHeaderClick,
      _onForceMobileChange = props.onForceMobileChange;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderContainerWrapper, {
    width: "page",
    theme: "dark",
    activeElement: activeElement,
    isFullUnderline: false,
    isMobile: isMobile,
    hasOpenFlyout: openPath !== undefined && !isMobile,
    isSticky: isSticky,
    onScrollChangeCallback: function onScrollChangeCallback(s) {
      return setScrollPosition(s);
    },
    onForceMobileChange: function onForceMobileChange(onForceMobileValue) {
      return _onForceMobileChange(onForceMobileValue);
    },
    logo: /*#__PURE__*/React.createElement(LogoPresentation, {
      scrollPosition: scrollPosition,
      variant: isMobile ? "mobile" : "vertical",
      disabled: logoDisabled,
      href: logoHref,
      onClick: onLogoClick,
      alt: logoAlt,
      srcCustom: isMobile ? logoSrcMobile : logoSrcDesktop,
      htmlAttrs: Object.assign({
        "aria-label": texts.lsg.component.Logo.actionHome
      }, logoHtmlAttrs),
      fitToBox: true
    }),
    onClick: onHeaderClick,
    segmentLabel: segmentLabel,
    topLeft: !isMobile && segmentNavigationTree && /*#__PURE__*/React.createElement(NavigationBarPresentation, {
      size: "segment-bar",
      navigationTree: segmentNavigationTree,
      value: segmentValue,
      onChange: function onChange(v, e) {
        onSegmentChange(v, name, e);
      }
    }),
    topRight: /*#__PURE__*/React.createElement(Div, {
      ref: mobileMenuLinkRef,
      className: "".concat(hostClass, "-top-right")
    }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true
    }, isMobile ? iconLinksMobileHeader : iconLinksInteraction, isMobile && /*#__PURE__*/React.createElement(IconLinkWrapper, {
      icon: interaction___menu,
      look: "no-text",
      onClick: function onClick() {
        return onOpenChange("");
      }
    }, "Open Menu"))),
    bottomLeft: !isMobile && /*#__PURE__*/React.createElement(Div, {
      ref: navigationBarRef
    }, /*#__PURE__*/React.createElement(NavigationBarPresentation, {
      navigationTree: navigationTree,
      value: ((_a = openPath === null || openPath === void 0 ? void 0 : openPath[0]) === null || _a === void 0 ? void 0 : _a.name) || ((_b = selectedPath[0]) === null || _b === void 0 ? void 0 : _b.name),
      onChange: function onChange(v, e) {
        var _a;

        if ((_a = navigationTree.find(function (item) {
          return item.name === v;
        })) === null || _a === void 0 ? void 0 : _a.children) {
          onOpenChange(v);
        } else {
          _onChange(v, name, e);
        }
      },
      activeRef: activeRef
    })),
    bottomRight: !isMobile && /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true
    }, iconLinksQuickLink)
  }), /*#__PURE__*/React.createElement(ThemePresentation, {
    componentContext: true,
    componentName: "header"
  }, /*#__PURE__*/React.createElement(DrawerWrapper, {
    open: openPath !== undefined,
    layout: isMobile ? "layer-right" : "mega-menu",
    onBackdropClick: function onBackdropClick() {
      return onOpenChange(undefined);
    }
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, /*#__PURE__*/React.createElement(HeaderContainerWrapper, {
    width: "layer",
    theme: "elevated",
    isMobile: isMobile,
    topLeft: (openPath === null || openPath === void 0 ? void 0 : openPath.length) > 0 && /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true
    }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
      icon: interaction_arrows_chevronLeft,
      onClick: function onClick() {
        return onOpenChange("");
      }
    }, "Zur\xFCck")),
    topRight: /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true
    }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
      icon: interaction___close,
      onClick: function onClick() {
        return onOpenChange(undefined);
      },
      look: "no-text"
    }, "Schliessen"))
  })), isMobile && /*#__PURE__*/React.createElement(SectionPresentation, {
    look: "technical"
  }, ((openPath === null || openPath === void 0 ? void 0 : openPath.length) === 0 || true) && /*#__PURE__*/React.createElement("div", {
    style: {
      display: (openPath === null || openPath === void 0 ? void 0 : openPath.length) === 0 ? "block" : "none"
    }
  }, /*#__PURE__*/React.createElement(NavigationBlockPresentation, {
    navigationTree: navigationTree.map(function (_a) {
      var n = __rest(_a, ["children"]);

      return n;
    }),
    expandAll: true,
    alwaysShowIndicator: true,
    startLevel: (openPath === null || openPath === void 0 ? void 0 : openPath.length) === 0 ? "topic" : "group",
    onChange: function onChange(v, e) {
      var _a;

      if ((_a = navigationTree.find(function (item) {
        return item.name === v;
      })) === null || _a === void 0 ? void 0 : _a.children) {
        onOpenChange(v);
      } else {
        _onChange(v, name, e);
      }
    },
    value: ((_c = openPath === null || openPath === void 0 ? void 0 : openPath[0]) === null || _c === void 0 ? void 0 : _c.name) || ((_d = selectedPath[0]) === null || _d === void 0 ? void 0 : _d.name),
    activeRef: activeMobileRef,
    activeElement: activeMobileElement
  }), /*#__PURE__*/React.createElement(NavigationSeparatorPresentation, null), /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    direction: "vertical"
  }, iconLinksMobileSidebar)), ((openPath === null || openPath === void 0 ? void 0 : openPath.length) > 0 || true) && navigationTree.map(function (item) {
    var _a, _b;

    return item.children && /*#__PURE__*/React.createElement(NavigationBlockPresentation, {
      navigationTree: item.children,
      expandAll: true,
      startLevel: "group",
      onChange: function onChange(v, e) {
        // TODO check if leaf node
        _onChange(v, name, e);
      },
      value: value,
      activeRef: activeMobileSubmenuRef,
      activeElement: activeMobileSubmenuElement,
      style: {
        display: ((_b = (_a = openPath === null || openPath === void 0 ? void 0 : openPath.slice(-1)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) === item.name ? "block" : "none"
      }
    });
  }), segmentNavigationTree && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationSeparatorPresentation, null), /*#__PURE__*/React.createElement(NavigationBlockPresentation, {
    navigationTree: segmentNavigationTree,
    expandAll: true,
    startLevel: "group",
    value: segmentValue,
    onChange: function onChange(v, e) {
      onSegmentChange(v, name, e);
    }
  }))), !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-flyout-close")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-flyout-close-link")
  }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    noMargin: true
  }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
    look: "no-text",
    icon: interaction___close,
    onClick: function onClick() {
      return onOpenChange(undefined);
    }
  }, "Schliessen")))), /*#__PURE__*/React.createElement(SectionPresentation, {
    look: "doublesubsection"
  }, /*#__PURE__*/React.createElement(GridPresentation, null, navigationTree.map(function (item) {
    var _a, _b;

    return /*#__PURE__*/React.createElement("div", {
      className: getGridRowClasses({}),
      style: {
        display: ((_a = openPath === null || openPath === void 0 ? void 0 : openPath[0]) === null || _a === void 0 ? void 0 : _a.name) === item.name ? "flex" : "none"
      }
    }, (_b = item === null || item === void 0 ? void 0 : item.children) === null || _b === void 0 ? void 0 : _b.map(function (navigation) {
      var _a;

      return /*#__PURE__*/React.createElement(GridColumnPresentation, {
        key: navigation.name,
        size: Math.floor(12 / item.children.length)
      }, /*#__PURE__*/React.createElement(NavigationBlockPresentation, {
        navigationTree: [navigation],
        expandAll: true,
        noIndent: true,
        startLevel: "group",
        onChange: function onChange(v, e) {
          return _onChange(v, name, e);
        },
        value: value,
        activeRef: activeSubmenuRef,
        activeElement: ((_a = selectedPath === null || selectedPath === void 0 ? void 0 : selectedPath[1]) === null || _a === void 0 ? void 0 : _a.name) === navigation.name ? activeSubmenuElement : undefined
      }));
    }));
  }))))))));
}, defaultProps);

export { PortalHeaderPresentation, defaultProps };
